"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var AddToCartButton = function AddToCartButton(_ref) {
  var addToCartText = _ref.addToCartText,
    totalPrice = _ref.totalPrice,
    onAddToCart = _ref.onAddToCart,
    disabled = _ref.disabled,
    checkoutDisabled = _ref.checkoutDisabled;
  var addToCartTextStyle = checkoutDisabled ? {} : {
    "float": 'left'
  };
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    primary: true,
    onClick: onAddToCart,
    disabled: disabled || checkoutDisabled
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: addToCartTextStyle
  }, addToCartText), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      "float": 'right'
    }
  }, !checkoutDisabled && "$".concat(totalPrice.toFixed(2))));
};
var _default = AddToCartButton;
exports["default"] = _default;